import { SummaryQualityPage } from '@/features/summary-quality/SummaryQualityPage';

export default SummaryQualityPage;
